export const URL = 'https://api.cleanteam.app:8081/api/v1'

